import { render, staticRenderFns } from "./goodsStock.vue?vue&type=template&id=0a1a75b1&"
import script from "./goodsStock.vue?vue&type=script&lang=js&"
export * from "./goodsStock.vue?vue&type=script&lang=js&"
import style0 from "./goodsStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports